import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class NumberService {
  private http = inject(HttpClient);

  getNumbers(search: string, providerCodeId: number | null, dateStart: string, dateEnd: string) {
    return this.http.get<any>(
      environment.apiUrl +
        'archived-numbers?' +
        'search=' +
        search +
        '&providerCodeId=' +
        providerCodeId +
        '&dateStart=' +
        dateStart +
        '&dateEnd=' +
        dateEnd,
    );
  }

  getNumbersForDailyArchive() {
    return this.http.get<any>(environment.apiUrl + 'daily-archived-numbers');
  }

  pingNumber(numberId: number, providerCodeId: number) {
    return this.http.post<any>(environment.apiUrl + 'ping-number', {
      number_id: numberId,
      provider_code_id: providerCodeId,
    });
  }
}
